import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { t } from '../i18n';
import { products, getProductById, getRelatedProducts, getShortDescription } from './ProductData';
import './ProductDetail.css';
import './Products.css';
import { FaMale, FaFemale } from 'react-icons/fa';

const StarRating = ({ rating, size = "small" }) => {
  const starSize = size === "large" ? "star-large" : "";
  return (
    <div className={`star-rating ${starSize}`}>
      {[1, 2, 3, 4, 5].map(star => (
        <span key={star} className={star <= rating ? 'star filled' : 'star'}>★</span>
      ))}
    </div>
  );
};

const generateReviews = (productId, language = 'bg') => {
  // Example reviews for each product
  const reviewsData = {
    1: [
      { name: { bg: 'Мария Петрова', en: 'Maria Petrova' }, gender: 'female', rating: 5, comment: { bg: 'Изключителен продукт! Кожата ми се чувства много по-добре.', en: 'Outstanding product! My skin feels so much better.' }, date: { bg: '15 юни 2024', en: 'June 15, 2024' } },
      { name: { bg: 'Иван Георгиев', en: 'Ivan Georgiev' }, gender: 'male', rating: 5, comment: { bg: 'Видими резултати само след няколко седмици.', en: 'Visible results after just a few weeks.' }, date: { bg: '20 юни 2024', en: 'June 20, 2024' } },
      { name: { bg: 'Елена Стоянова', en: 'Elena Stoyanova' }, gender: 'female', rating: 4, comment: { bg: 'Много съм доволна от продукта.', en: 'Very satisfied with the product.' }, date: { bg: '25 юни 2024', en: 'June 25, 2024' } }
    ],
    2: [
      { name: { bg: 'Георги Димитров', en: 'Georgi Dimitrov' }, gender: 'male', rating: 5, comment: { bg: 'Препоръчвам го на всички!', en: 'I recommend it to everyone!' }, date: { bg: '10 юни 2024', en: 'June 10, 2024' } },
      { name: { bg: 'Силвия Иванова', en: 'Silvia Ivanova' }, gender: 'female', rating: 4, comment: { bg: 'Много добър ефект.', en: 'Very good effect.' }, date: { bg: '12 юни 2024', en: 'June 12, 2024' } },
      { name: { bg: 'Петър Петров', en: 'Petar Petrov' }, gender: 'male', rating: 5, comment: { bg: 'Ще купя отново.', en: 'Will buy again.' }, date: { bg: '18 юни 2024', en: 'June 18, 2024' } }
    ],
    3: [
      { name: { bg: 'Даниела Костова', en: 'Daniela Kostova' }, gender: 'female', rating: 5, comment: { bg: 'Страхотен продукт за възстановяване.', en: 'Great product for recovery.' }, date: { bg: '5 юни 2024', en: 'June 5, 2024' } },
      { name: { bg: 'Мартин Николов', en: 'Martin Nikolov' }, gender: 'male', rating: 4, comment: { bg: 'Доволен съм от резултатите.', en: 'Satisfied with the results.' }, date: { bg: '8 юни 2024', en: 'June 8, 2024' } },
      { name: { bg: 'Росица Тодорова', en: 'Rositsa Todorova' }, gender: 'female', rating: 5, comment: { bg: 'Бърз ефект и лесно приложение.', en: 'Quick effect and easy to use.' }, date: { bg: '15 юни 2024', en: 'June 15, 2024' } }
    ],
    4: [
      { name: { bg: 'Антон Антонов', en: 'Anton Antonov' }, gender: 'male', rating: 5, comment: { bg: 'Много съм впечатлен.', en: 'Very impressed.' }, date: { bg: '2 юни 2024', en: 'June 2, 2024' } },
      { name: { bg: 'Виктория Василева', en: 'Viktoria Vasileva' }, gender: 'female', rating: 5, comment: { bg: 'Прекрасен продукт!', en: 'Wonderful product!' }, date: { bg: '7 юни 2024', en: 'June 7, 2024' } },
      { name: { bg: 'Стефан Стефанов', en: 'Stefan Stefanov' }, gender: 'male', rating: 4, comment: { bg: 'Работи отлично.', en: 'Works great.' }, date: { bg: '14 юни 2024', en: 'June 14, 2024' } }
    ],
    5: [
      { name: { bg: 'Галя Георгиева', en: 'Galya Georgieva' }, gender: 'female', rating: 5, comment: { bg: 'Перфектен за чувствителна кожа.', en: 'Perfect for sensitive skin.' }, date: { bg: '3 юни 2024', en: 'June 3, 2024' } },
      { name: { bg: 'Ивайло Иванов', en: 'Ivaylo Ivanov' }, gender: 'male', rating: 5, comment: { bg: 'Много добър продукт.', en: 'Very good product.' }, date: { bg: '9 юни 2024', en: 'June 9, 2024' } },
      { name: { bg: 'Снежана Петрова', en: 'Snejana Petrova' }, gender: 'female', rating: 4, comment: { bg: 'Доволна съм от резултата.', en: 'Happy with the result.' }, date: { bg: '13 юни 2024', en: 'June 13, 2024' } }
    ],
    6: [
      { name: { bg: 'Пламен Пламенов', en: 'Plamen Plamenov' }, gender: 'male', rating: 5, comment: { bg: 'Изключително доволен.', en: 'Extremely satisfied.' }, date: { bg: '6 юни 2024', en: 'June 6, 2024' } },
      { name: { bg: 'Милена Миленова', en: 'Milena Milenova' }, gender: 'female', rating: 5, comment: { bg: 'Препоръчвам го горещо.', en: 'Highly recommend it.' }, date: { bg: '11 юни 2024', en: 'June 11, 2024' } },
      { name: { bg: 'Димитър Димитров', en: 'Dimitar Dimitrov' }, gender: 'male', rating: 4, comment: { bg: 'Много добър ефект.', en: 'Very good effect.' }, date: { bg: '17 юни 2024', en: 'June 17, 2024' } }
    ],
    7: [
      { name: { bg: 'Теодора Тодорова', en: 'Teodora Todorova' }, gender: 'female', rating: 5, comment: { bg: 'Косата ми е по-здрава и лъскава.', en: 'My hair is healthier and shinier.' }, date: { bg: '4 юни 2024', en: 'June 4, 2024' } },
      { name: { bg: 'Александър Александров', en: 'Alexander Alexandrov' }, gender: 'male', rating: 5, comment: { bg: 'Много съм доволен.', en: 'Very happy.' }, date: { bg: '8 юни 2024', en: 'June 8, 2024' } },
      { name: { bg: 'Валентина Василева', en: 'Valentina Vasileva' }, gender: 'female', rating: 4, comment: { bg: 'Препоръчвам го.', en: 'I recommend it.' }, date: { bg: '16 юни 2024', en: 'June 16, 2024' } }
    ]
  };
  const totalReviews = reviewsData[productId]?.length || 0;
  return {
    textReviews: reviewsData[productId] || [],
    totalCount: totalReviews
  };
};

const ProductPage = ({ language = 'bg' }) => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    const foundProduct = getProductById(productId);
    if (foundProduct) {
      setProduct(foundProduct);
      
      // Set page title for SEO
      document.title = `${t(foundProduct.name, language)} - EXOREVIVE BULGARIA`;
      
      // Add meta description for SEO
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', foundProduct.fullDescription[language] || foundProduct.fullDescription.bg);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = foundProduct.fullDescription[language] || foundProduct.fullDescription.bg;
        document.head.appendChild(meta);
      }
    } else {
      navigate('/products');
    }
    
    const timer = setTimeout(() => setImageLoaded(true), 200);
    return () => clearTimeout(timer);
  }, [productId, language, navigate]);
  
  if (!product) {
    return <div className="loading-container">Loading...</div>;
  }
  
  const { textReviews, totalCount } = generateReviews(product.id, language);
  const averageRating = totalCount > 0 ? 
    (textReviews.reduce((sum, review) => sum + review.rating, 0) / textReviews.length).toFixed(1) : 0;

  const handleImageClick = () => {
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
  };

  const handleInquire = () => {
    navigate('/contact');
  };
  
  const getFullDescription = () => {
    return product.fullDescription[language] || product.fullDescription.bg || "";
  };

  const getDetailedInfo = () => {
    return product.detailedInfo[language] || product.detailedInfo.bg || "";
  };
  
  const relatedProducts = getRelatedProducts(product, 3);
  
  return (
    <div className="product-page-container">
      <div className="breadcrumb">
        <Link to="/">{t('Начало', language)}</Link> &gt;
        <Link to="/products">{t('Продукти', language)}</Link> &gt;
        <span>{t(product.name, language)}</span>
      </div>
      
      <div className="product-detail">
        <div className="product-detail-container">
          <Link to="/products" className="back-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5m7-7l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('Назад към продуктите', language)}
          </Link>
          
          <div className="product-layout">
            {/* Left Column - Image */}
            <div className="product-left-column">
              <div className={`product-detail-image-wrap ${imageLoaded ? 'loaded' : ''}`} onClick={handleImageClick}>
                <img 
                  src={product.image} 
                  alt={t(product.name, language)} 
                  className="product-detail-image"
                  onLoad={() => setImageLoaded(true)}
                />
              </div>
              
              {/* Sticky Buy Button */}
              <div className="sticky-buy-button">
                <button className="inquire-btn" onClick={handleInquire}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M3 8l7.89 7.89a2 2 0 002.82 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {t('Направи запитване', language)}
                </button>
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="product-right-column">
              <div className="product-header-section">
                <div className="product-category-pill">{t(product.category, language)}</div>
                <h1 className="product-detail-title" style={{ color: '#1a1a1a' }}>{t(product.name, language)}</h1>
                <div className="product-rating-summary">
                  <StarRating rating={Math.round(averageRating)} size="large" />
                  <span className="rating-text">({averageRating}) • {totalCount} {t('отзива', language)}</span>
                </div>
              </div>

              <div className="product-content-sections">
                {/* Short Description Section */}
                <div className="product-section short-desc-section">
                  <h2>{t('Кратко описание', language)}</h2>
                  <p className="short-description">{getShortDescription(product.id, language)}</p>
                  <p>{getFullDescription()}</p>
                </div>

                {/* Detailed Description Section */}
                <div className="product-section detailed-desc-section">
                  <h2>{t('Подробно описание', language)}</h2>
                  <div className="description-content">
                    <div className="detailed-description">
                      {getDetailedInfo().split('\n\n').map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Reviews Section */}
                <div className="product-section reviews-section">
                  <h2>{t('Отзиви', language)} ({totalCount})</h2>
                  <div className="reviews-masonry">
                    {textReviews.map((review, index) => (
                      <div key={index} className="review-card">
                        <div className="review-header">
                          <div className="reviewer-info">
                            <span className="reviewer-name">{review.name[language] || review.name.bg}</span>
                            <StarRating rating={review.rating} />
                          </div>
                          <span className="review-date">{review.date[language] || review.date.bg}</span>
                        </div>
                        <p className="review-comment">{review.comment[language] || review.comment.bg}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showImageModal && (
            <div className="image-modal" onClick={closeImageModal}>
              <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={closeImageModal}>×</button>
                <img src={product.image} alt={t(product.name, language)} className="modal-image" />
              </div>
            </div>
          )}
        </div>
        
        {/* Related Products Section */}
        <div className="related-products-section">
          <h2>{t('Свързани продукти', language)}</h2>
          <div className="related-products-grid">
            {relatedProducts.map(relatedProduct => (
              <div className="related-product-card" key={relatedProduct.id}>
                <Link to={`/product/${relatedProduct.id}`}>
                  <div className="related-product-image">
                    <img src={relatedProduct.image} alt={t(relatedProduct.name, language)} />
                  </div>
                  <h3>{t(relatedProduct.name, language)}</h3>
                  <p>{t(relatedProduct.desc, language)}</p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage; 